import { render, staticRenderFns } from "./ConstructionPopup.vue?vue&type=template&id=5c4dad8a"
import script from "./ConstructionPopup.vue?vue&type=script&lang=js"
export * from "./ConstructionPopup.vue?vue&type=script&lang=js"
import style0 from "./ConstructionPopup.vue?vue&type=style&index=0&id=5c4dad8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports